import { RootState } from 'store/root-reducer';

export const getWimsStatus = (state: RootState) => state.statistics.wimsStatus;
